import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, factory, List, Stack, Text, Title, useProps, useStyles } from "@coveord/plasma-mantine";
import { Children } from "react";
import { PrerequisitesListProvider } from "./PrerequisitesList.context.js";
import classes from "./PrerequisitesList.module.css";
import { PrerequisitesListItem } from "./PrerequisitesListItem.js";
var defaultProps = {};
export var PrerequisitesList = factory(function(_props, ref) {
    var props = useProps("PrerequisitesList", defaultProps, _props);
    var children = props.children, iconFailure = props.iconFailure, iconSuccess = props.iconSuccess, staticItemsTitle = props.staticItemsTitle, staticItemsDescription = props.staticItemsDescription, title = props.title, classNames = props.classNames, className = props.className, styles = props.styles, style = props.style, unstyled = props.unstyled;
    var getStyles = useStyles({
        name: "PrerequisitesList",
        classes: classes,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    var items = Children.toArray(children).filter(function(child) {
        return child.type === PrerequisitesListItem;
    });
    var prerequisites = items.filter(function(item) {
        return item.props.status !== "static";
    });
    var suggestions = items.filter(function(item) {
        return item.props.status === "static";
    });
    return /*#__PURE__*/ _jsx(PrerequisitesListProvider, {
        value: {
            getStyles: getStyles,
            iconFailure: iconFailure,
            iconSuccess: iconSuccess
        },
        children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, getStyles("root")), {
            children: /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
                ref: ref,
                gap: "sm",
                p: "sm",
                pr: "md",
                display: "inline-flex"
            }, getStyles("container")), {
                children: [
                    /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({
                        order: 5
                    }, getStyles("title")), {
                        children: title
                    })),
                    /*#__PURE__*/ _jsx(List, _object_spread_props(_object_spread({
                        spacing: "xs",
                        center: true
                    }, getStyles("itemsListContainer")), {
                        children: prerequisites
                    })),
                    suggestions.length > 0 && prerequisites.length > 0 && /*#__PURE__*/ _jsx(Divider, {}),
                    suggestions.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({
                                order: 5
                            }, getStyles("title")), {
                                children: staticItemsTitle
                            })),
                            staticItemsDescription && /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({}, getStyles("description")), {
                                children: staticItemsDescription
                            })),
                            /*#__PURE__*/ _jsx(List, _object_spread_props(_object_spread({
                                spacing: "xs",
                                center: true
                            }, getStyles("itemsListContainer")), {
                                listStyleType: "disc",
                                children: suggestions
                            }))
                        ]
                    })
                ]
            }))
        }))
    });
});
PrerequisitesList.Item = PrerequisitesListItem;
PrerequisitesList.displayName = "@components/mantine/PrerequisitesList";

//# sourceMappingURL=PrerequisitesList.js.map